import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { AppointmentNote } from "models";

type RecurringCarNoteProps = {
  note?: AppointmentNote;
};

export const RecurringCarNote = ({ note: recurringCarNote }: RecurringCarNoteProps) => {
  const { t } = useTranslation();

  return (
    <Popup
      wide
      basic
      disabled={!recurringCarNote}
      content={
        recurringCarNote && (
          <div className="AppointmentNotePopup">
            <div className="AppointmentNoteTitle">
              <Icon className="warning sign red" color="red" />

              <span>{t("v8_recurring_car", "Recurring car")}</span>
            </div>
            <div className="AppointmentNoteDescription">
              {recurringCarNote.updated_by
                ? `${t("v8_updated_by", "Updated by")} ${recurringCarNote.updated_by.first_name} ${recurringCarNote.updated_by.last_name} ${t("v8_at", "at")} `
                : `${t("v8_added_by", "Added by")}  ${recurringCarNote.created_by?.first_name} ${recurringCarNote.created_by?.last_name} ${t("v8_at", "at")} `}
              {`${formatDate(recurringCarNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
            </div>
            <div className="AppointmentNoteContent">{recurringCarNote.note}</div>
          </div>
        )
      }
      trigger={
        <Label circular color="red">
          <Icon name="warning sign" />
        </Label>
      }
    />
  );
};
